import React from 'react'
import { Helmet } from 'react-helmet'

interface WindowTitleProps {
  title: string
}

export const WindowTitle: React.FC<WindowTitleProps> = ({ title }) => {
  return !title ? null : (
    <Helmet title={`${title} | HomeViews Developer Portal`} />
  )
}
